import React, { useContext } from "react";

import { HandlerContext } from "../../../../../lnb/LnbWrapper";

function ListItem({ category, titleText, contentText, link, callEmptyAlert, drawCd }) {
    const handlerContext = useContext(HandlerContext);

    const handleClickListItem = () => {
        handlerContext.clickMenuTypeCodeLINK({ LINK: link }, drawCd);
        callEmptyAlert();
    };

    return (
        <div className="clear infortxtbox2" onClick={handleClickListItem}>
            <div className="fl infortxt1">
                <span>{category}</span> {titleText}
            </div>
            <div className="fr infortxt2">{contentText}</div>
        </div>
    );
}

export default ListItem;
